import MainLayout from '../../components/MainLayout';

export default MainLayout;
